import { Author } from "../manifest/models/author.models";

export function getUsernameFor(user: Author): string {
  if (user.last == null || user.last == "") {
    return user.first;
  }

  return `${user.first} ${user.last}`;
}
